function CookiesController(){
    this.glob				            = "/**";
    this.cookieName                     = 'cookiesAccepted';
    this.googleAnalyticsScriptLoaded    = false;
};

CookiesController.inheritsFrom( StandardController );

CookiesController.prototype.on = function(){
    if (this.isSetup) {
        if (this.cookiesAccepted()) {
            if (!this.googleAnalyticsScriptLoaded) this.loadGoogleAnalyticsScript();
        }
    } else {
        this.setup();
        if (this.cookiesAccepted()) {
            if (!this.googleAnalyticsScriptLoaded) this.loadGoogleAnalyticsScript();
        } else {
            this.showCookiesPopUp();
        }
    }

};

CookiesController.prototype.setup = function(state){

    if(this.isSetup) return false;

    this.cookiesPopUp               = $('.cookies');
    this.$acceptButton 				= $(".js-accept-cookies-button");
    this.$declineButton 			= $(".js-decline-cookies-button");
    this.$closeButton               = $('.js-close-button');

    this.$acceptButton.on('click', () => this.acceptCookies())
    this.$declineButton.click('click', () => this.declineCookies());
    this.$closeButton.click('click', () => this.declineCookies());
    
	this.isSetup = true;
}

CookiesController.prototype.cookiesAccepted = function() {
    return this.getCookie(this.cookieName);
}

CookiesController.prototype.showCookiesPopUp = function() {
    this.cookiesPopUp.show();
}

CookiesController.prototype.acceptCookies = function() {
    this.setCookie(this.cookieName, 1, 365);
    this.loadGoogleAnalyticsScript();
    // this.sendInitialPageviewToGoogleAnalytics();
    this.cookiesPopUp.hide();
}

CookiesController.prototype.setCookie = function(cookieName, cookieValue, cookieExpirationDays) {
    const date = new Date();
    date.setTime( date.getTime() + (cookieExpirationDays * 24 * 60 * 60 * 1000) );
    const expires = "expires="+ date.toUTCString();
    document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
}

CookiesController.prototype.getCookie = function(cookieName) {
    var name = cookieName + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookiesArray = decodedCookie.split(';');
    for(var i = 0; i <cookiesArray.length; i++) {
      var cookie = cookiesArray[i];
      while (cookie.charAt(0) == ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(name) == 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
    return "";
}

CookiesController.prototype.declineCookies = function() {
    this.cookiesPopUp.hide();
}

// The function below needs to be public.
// It throws errors and doesn't work when added to CookiesController
// To be investigated later when we have time.
function runAnalytics() {
    (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window,document,'script','//www.google-analytics.com/analytics.js','ga');

    ga('create', 	googleAnalyticsId, 'auto');
    ga('send', 		'pageview');

    console.log('%c[runAnalytics] send pageview', 'background: yellow', nav.getState().nextUrl)
}

CookiesController.prototype.loadGoogleAnalyticsScript = function() {
    console.log('loadGoogleAnalyticsScript')
    runAnalytics();
    this.googleAnalyticsScriptLoaded = true;

}